<template>
    <div class="banner">
        <div class="banner-bg" style="background-image: url('/bjj.png');">
            <div class="left">
                <!-- <div class="logo"></div>
                <div class="title_box">
                    <div class="t1">山东环境科学学会</div>
                    <div class="t2">Shandong Environmental Science Society</div>
                </div> -->
            </div>
            <div class="right">
                <div class="r_t1">
                    <!-- <div class="t3">规范 专业</div> -->
                    <div class="language-switch">
                        <div class="eng" @click="switchLanguage" :class="[item.value == language ? 'active_eng' : '']"
                            v-for="(item, index) in languageList" :key="index">{{ item.name }}</div>
                    </div>
                </div>
                <div class="r_t2">
                    <!-- <div class="t3">诚信 和谐</div> -->
                </div>
                <div class="r_t3">
                    <div class="search_box">
                        <img src="../assets/img/sousuo.png" class="icon" />
                        <input type="text" class="input" placeholder="输入搜索" v-model.trim="searchQuery"
                            @keyup.enter="search" />
                        <div class="btn" @click="search">搜索</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nav">
            <ul>
                <div class="nav_list" :class="[selNav.id === item.id ? 'active_nav' : '']"
                    v-for="(item, index) in navlist" :key="index" @click.stop="SelItem1(item, index)">
                    <li class="name">{{ item.name }}</li>
                    <div class="nav-item-box" v-if="index !== 0">
                        <div class="font" v-for="(cle, cindex) in item.children" :key="cindex"
                            @click.stop="SelItem2(item, index, cle, cindex)">{{ cle.name }}</div>
                    </div>
                </div>
            </ul>
        </div>
    </div>
</template>
<script setup>
import { ref, getCurrentInstance, onMounted, reactive, watch } from 'vue'
const api = getCurrentInstance().proxy.$api;
import { useRouter, useRoute } from 'vue-router';
const router = useRouter()
const route = useRoute()
import { useStore } from 'vuex'
const store = useStore()
//导航1级
const SelItem1 = (item, index) => {
    if (index == 0) {
        store.commit('setSelNav', navlist.value[0])
        selNav.value = JSON.parse(sessionStorage.getItem('selNav'))
        router.push('/')
    }
}
//导航2级
const SelItem2 = (item, index, cle, cindex) => {
    const id = cle.id
    //存储选中导航对象数据
    store.commit('setSelNav', item)
    //存储选中导航ids
    let ids = {
        id1: cle.id,
        id2: -1
    }
    store.commit('setSelNavId', ids)
    selNav.value = JSON.parse(sessionStorage.getItem('selNav'))
    //证书查询
    if (id == 34) {
        router.push({ path: '/education', query: { id: id } })
        return
    }
    router.push({ path: '/list/link_list', query: { id: id } })
}
//语言切换
//获取本地存储语言
const languageList = [{
    value: 1, name: '中',
}, {
    value: 2, name: 'En',
}];
//1 中文  2 英文
const language = ref(localStorage.getItem('language') || 1);  //1 中文  2 英文
store.commit('setLanguage', language.value)
const switchLanguage = () => {
    if (language.value == 1) {
        language.value = 2
    } else {
        language.value = 1
    }
    store.commit('setLanguage', language.value)
    catelist()
}
//分类列表
let navlist = ref([])
const catelist = async () => {
    const res = await api.post('/index/catelist', { language: store.state.language })
    navlist.value = res.data || []
    store.commit('setNavList', navlist.value)
}
//获取存储导航
const selNav = ref(JSON.parse(sessionStorage.getItem('selNav')))
//搜索
const searchQuery = ref('')
const search = () => {
    //抛出一个方法外部都能调用
    store.commit('setSearch', searchQuery.value)
}
onMounted(async () => {
    await catelist()
    //本地存储选中的导航
    if (selNav.value && selNav.value.id) {
        store.commit('setSelNav', selNav.value)
        selNav.value = JSON.parse(sessionStorage.getItem('selNav'))
    } else {
        store.commit('setSelNav', navlist.value[0])
        selNav.value = JSON.parse(sessionStorage.getItem('selNav'))
    }
})
</script>
<style scoped lang="scss">
.banner {
    width: 100%;

    .banner-bg {
        width: 100%;
        aspect-ratio: 960 / 133;
        padding: 20px 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        position: relative;
        background-color: #0085E4;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;

        .left {
            display: flex;
            align-items: center;
            min-width: 0;
            flex: 1;
            position: relative;
            z-index: 1;

            .logo {
                width: 120px;
                height: 120px;
                border-radius: 100%;
                background: #ffffff;
                margin-right: 20px;
            }

            .title_box {
                text-align: left;
                font-family: Source Han Serif CN, Source Han Serif CN;
                font-weight: 800;
                color: #FFFFFF;
                text-shadow: 2px 5px 0px rgba(0, 0, 0, 0.12);
                min-width: 0;
                overflow: hidden;

                .t1 {
                    font-size: clamp(24px, 4vw, 50px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .t2 {
                    font-size: clamp(12px, 2vw, 26px);
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .right {
            height: 100%;
            max-width: 450px;
            width: 30%;
            min-width: 280px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 10px 20px 40px;
            box-sizing: border-box;
            position: relative;
            z-index: 1;

            .t3 {
                font-family: Source Han Serif CN, Source Han Serif CN;
                font-weight: 800;
                font-size: 34px;
                color: #FFFFFF;
                text-shadow: 2px 5px 0px rgba(0, 0, 0, 0.12);
            }

            .r_t1 {
                display: flex;
                align-items: center;
                justify-content: flex-end;

            }

            .r_t3 {
                .search_box {
                    width: 100%;
                    background: #FFFFFF;
                    border-radius: 12px;
                    padding: 3px 3px 3px 10px;
                    display: flex;
                    align-items: center;

                    .icon {
                        width: 17px;
                        height: 17px;
                        margin-right: 10px;
                    }

                    .input {
                        width: 100%;
                        font-size: 16px;
                        padding: 10px 0;
                    }

                    .btn {
                        margin-left: 10px;
                        width: 73px;
                        height: 39px;
                        background: #0890F1;
                        border-radius: 10px;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 39px;
                        cursor: pointer;
                    }
                }
            }

            .language-switch {
                display: flex;
                align-items: center;
                width: 80px;
                height: 30px;
                background: #FFFFFF;
                border-radius: 16px;
                border: 1px solid #0085E4;
                cursor: pointer;

                .eng {
                    width: 50%;
                    font-family: Source Han Serif CN, Source Han Serif CN;
                    font-weight: bold;
                    font-size: 14px;
                    color: #0085E4;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .active_eng {
                    height: 100%;
                    background: #0085E4;
                    border-radius: 16px;
                    color: #FFFFFF;
                }
            }
        }
    }

    .nav {
        width: 100%;
        max-width: 100%;
        background: #0085E4;
        display: flex;
        justify-content: center;

        ul {
            list-style: none;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            height: 60px;
            cursor: pointer;
            width: 100%;
        }
    }
}

.nav_list {
    height: 100%;
    flex: 1;
    min-width: 0;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 22px;
    color: #FFFFFF;
    text-align: center;
    line-height: 60px;
    position: relative;
}

.name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.active_nav {
    // font-weight: bold;
    background: #339EEA;
}

.nav-item-box {
    width: 100%;
    position: absolute;
    padding: 2px;
    display: flex;
    flex-direction: column;
    top: 100%;
    left: 50%;
    transform: translateX(-50%) scaleY(0);
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
    overflow: hidden;
    transition: .3s;
    transform-origin: top;
    background: #FFF;
    color: #292929;
    box-shadow: 0 0 10px rgba(0, 0, 0, .3);
    z-index: 10;
    font-weight: 0 !important;

    .font {
        font-size: 17px;

    }
}

.nav_list:hover .nav-item-box {
    filter: alpha(opacity=100);
    -moz-opacity: 1;
    -khtml-opacity: 1;
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) scaleY(1);
}

.nav-list-box ul>li:hover .font {
    text-decoration: none;
}

.nav-item-box .font:hover {
    color: #FFF;
    background-color: #339EEA;
    text-decoration: none;
}
</style>